export default __webpack_public_path__ + "static/media/heart-waiting-grey.ecfe3929.svg";